export default __webpack_public_path__ + "static/media/gear.be3f46b7.svg";